const frame = (linksId,frameId,close) => {
    const links = document.querySelectorAll(linksId),
          closeTriggers = document.querySelectorAll(close),
          frame = document.querySelector(frameId);

    links.forEach( link => {
        link.addEventListener('click', e => {
            e.preventDefault();
  
            frame.querySelector('iframe').src = link.getAttribute('data-frame');
            frame.style.display = 'block';
        });
    });
    document.querySelector('.welcome__promo a').addEventListener('click', e => {
        e.preventDefault();

        frame.querySelector('iframe').src = document.querySelector('.welcome__promo a').getAttribute('data-frame');
            frame.style.display = 'block';
    });
    closeTriggers.forEach( triger => {
        triger.addEventListener('click', () => {
            frame.style.display = 'none';
        });
    });
};

export default frame;